namespace $.$$ {
	$mol_style_define($bog_formigo_filler_step, {
		padding: $mol_gap.block,
		gap: '1rem',

		Label: {
			font: {
				size: '1.5rem',
				weight: 'bold',
			},
		},

		Required_badge: {
			color: $mol_theme.special,
			font: {
				size: '.8rem',
			},
		},

		Suggestion: {
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			padding: $mol_gap.text,
			font: {
				size: '.85rem',
			},
		},
	})
}
